import type { DisplayOptions } from './filter-models';
import type { FilterBlock, RuleDescription } from './parsing-models';
import type { GameItem } from './game-item.models';

export class SimulatorResult {
  constructor(init?: Partial<SimulatorResult>) {
    Object.assign(this, init);
  }

  error?: string;

  item!: GameItem;
  displayOptions?: DisplayOptions;

  noMatch?: boolean;
  styledByPartialRules?: FilterBlock[];
  shown?: boolean;
  rule?: RuleDescription;
  ruleFullText?: string;
  matchingBlock?: FilterBlock;

  warnings?: string[];
}
